<template>
  <div class="departmentTreeWrap">
    <div class="treeBox">
      <el-input placeholder="请输入关键字"
        v-model="filterText"> </el-input>
      <el-tree :data="treeData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        accordion
        :default-expanded-keys="treeExpandId"
        :filter-node-method="filterNode"
        @node-click="changeNode"
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
          height: 83%;
        ">
        <span class="custom-tree-node"
          slot-scope="{ node, data }">
          <span class="nameVal">{{ node.label }}</span>
          <span class="btnsBox"
            v-if="$parent.roleAuthority && defaultData.id == data.id">
            <i class="el-icon-edit"
              @click.stop="() => onSubmit(node, data, '编辑')"
              title="编辑"></i>
            <i class="el-icon-plus"
              @click.stop="() => onSubmit(node, data, '新增')"
              v-if="data.level < 3"
              title="新增"></i>
            <i class="el-icon-delete"
              @click.stop="() => remove(node, data)"
              v-if="node.level != 1"
              title="删除"></i>
          </span>
        </span>
      </el-tree>
    </div>
    <div class="btnBox">
      <el-button type="primary"
        v-if="$parent.roleAuthority"
        @click="clickActive('department')">部门权限</el-button>
      <el-button type="primary"
        @click="clickActive('user')">查询人员</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      filterText: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      treeExpandId: [],
      defaultData: {}, //默认选中的第一个数据
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    changeNode(data) {
      this.defaultData = data;
    },
    clickActive(type) {
      if (!this.$refs.tree.getCurrentNode()) {
        this.$message.error("请选择资产");
        return;
      }
      if (type == "user") {
        this.$emit("getTreeActive", this.$refs.tree.getCurrentNode());
      } else {
        if (this.$refs.tree.getCurrentNode().level === 1) {
          this.$message.error("不能操作一级部门权限");
          return;
        }
        this.$parent.powerDialogVisible = true;
        this.$emit("getActiveItem", this.$refs.tree.getCurrentNode());
      }
    },
    // 获取树结构数据
    async getTreeLists() {
      let _this = this;
      this.treeData = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.authorityGetDpartment({});
      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.treeData = res.data;
        this.$parent.treeAllData = res.data;
        this.$refs.tree.setCurrentKey();
        if (!this.defaultData.id) {
          function calleArr(array) {
            let data = array[0];
            if (data.children && data.children.length) {
              calleArr(data.children);
            } else {
              _this.defaultData = data;
            }
          }
          calleArr(_this.treeData);
        } else {
          let result = {};
          function getItem(data) {
            for (let i = 0; i < data.length; i++) {
              const oItem = data[i];
              if (oItem.id === _this.defaultData.id) {
                result = oItem;
                return;
              } else {
                if (oItem.children && oItem.children.length) {
                  getItem(oItem.children);
                }
              }
            }
          }
          getItem(_this.treeData);
          this.defaultData = result;
        }
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(_this.defaultData.id);
          this.treeExpandId = [];
          this.treeExpandId.push(_this.defaultData.id);
          this.$emit("getTreeActive", _this.defaultData);
        });
      }
    },
    // 新增或修改数据
    onSubmit(node, data, type) {
      this.$prompt(
        type == "新增" ? "请输入下级部门名称" : "请输入部门名称",
        type == "新增" ? "新增子级" : "修改",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          inputPattern: /\S/,
          inputErrorMessage: "部门名称不能为空",
        }
      )
        .then(async ({ value }) => {
          let paramsData = {};
          if (type == "新增") {
            paramsData = {
              pid: data.id,
              name: value,
              level: data.level + 1,
              sort: data.children ? data.children.length + 1 : 1,
              hasManage: true,
            };
          } else {
            paramsData = {
              id: data.id,
              name: value,
            };
          }
          let res = await api.authorityEditDepartment(paramsData);
          if (res && res.status == 200) {
            if (res.data.code == 200) {
              this.$message.success(type == "新增" ? "添加成功" : "修改成功");
              setTimeout(() => {
                this.getTreeLists();
              }, 500);
            } else {
              this.$message.error(res.data.codeMsg);
            }
          }
        })
        .catch(() => {});
    },
    update() {},
    remove(node, data) {
      this.$confirm("删除后该机构及其下属机构均被删除，是否确认？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$store.commit("SET_LOADING", true);
          let res = await api.authorityDeleteDepartment({}, data.id);
          if (res && res.status == 200) {
            this.$store.commit("SET_LOADING", false);
            if (res.data.code == 200) {
              this.$message.success("删除成功");
              this.defaultData = {};
              setTimeout(() => {
                this.getTreeLists();
              }, 500);
            } else {
              this.$message.error(res.data.codeMsg);
            }
          }
        })
        .catch(() => {});
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  created() {
    this.getTreeLists();
  },
};
</script>

<style lang="scss" scoped>
.departmentTreeWrap {
  @include setMenuWH;
  .treeBox {
    width: 93%;
    height: 80%;
    margin: 5% auto;
    overflow: auto;
    ::v-deep
      .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: $themeColor !important;
      color: #fff;
    }
    .custom-tree-node {
      @include setFlexBetween;
      width: 90%;
      .btnsBox {
        i {
          margin-right: 10px;
        }
      }
    }
  }
  .btnBox {
    text-align: center;
  }
}
</style>